import { useState, useCallback } from 'react';

export type ModalName = 'member' | 'editGroup' | 'alert' | 'clearMessage';

// modal state management
export const useGroupModals = () => {
  const [modals, setModals] = useState<Record<ModalName, boolean>>({
    member: false,
    editGroup: false,
    alert: false,
    clearMessage: false
  });
  const [removeUserId, setRemoveUserId] = useState('');

  const open = useCallback((modal: ModalName, userId?: string) => {
    setRemoveUserId(userId || '');
    setModals((prev) => ({ ...prev, [modal]: true }));
  }, []);

  const close = useCallback((modal: ModalName) => {
    if (modal === 'alert') setRemoveUserId('');
    setModals((prev) => ({ ...prev, [modal]: false }));
  }, []);

  return { modals, removeUserId, open, close };
};
